import React, { FunctionComponent, ReactElement } from 'react'

import { useIsAdmin, useIsManager, useIsCareCoordinator } from 'src/session'

type Render = (isAllowed: boolean) => ReactElement | null

type Props = {
  allowManager?: boolean
  allowCareCoordinator?: boolean
  render?: Render
}

const Authentication: FunctionComponent<Props> = (props) => {
  const { allowManager, allowCareCoordinator, children, render } = props
  const isAdmin = useIsAdmin()
  const isManager = useIsManager()
  const isCareCoordinator = useIsCareCoordinator()

  if (isAdmin) {
    return <>{!render ? children : render(true)}</>
  }
  if (allowManager && isManager) {
    return <>{!render ? children : render(true)}</>
  }
  if (allowCareCoordinator && isCareCoordinator) {
    return <>{!render ? children : render(true)}</>
  }
  return <>{!render ? null : render(false)}</>
}

export default Authentication
